import React from 'react';
import { styles } from './HexagonViewStyle';
import { ImageBackground, Text, View } from 'react-native';
import { TranslationView } from '@levelapp/softfabric-ui';
import Project from "../../../../../../../Common/DTO/Project";
import {translate} from "../../../../../../../Common/Utils/translation.utils";
import {useWindowSizeContext} from "../../../../../../../Common/contexts/WindowSizeContext";

interface HexagonViewProps {
  project: Project;
  isMobile: boolean;
}

export const HexagonView = ({ project }: HexagonViewProps) => {
  const { width, isMobile } = useWindowSizeContext();
  const hexagonSize = calculateHexagonSize();
  const hexagonFontSize: number = hexagonSize / 12;
  const separatorSize = hexagonSize * 0.45;

  function calculateHexagonSize() {
    if (isMobile) {
        return width * 0.275 > 125 ? 125 : width * 0.275;
    }
    return width * 0.1 > 160 ? 160 : width * 0.1;
  }

  function formatRate() {
    return project.annualInterestRate + " %";
  }

  function formatDuration() {
    return (project.duration > 1) ? project.duration + " " + translate("years")
        : project.duration + " " + translate("year");
  }

  return (
      <View style={[styles.hexagon, { width: hexagonSize, height: hexagonSize }]}>
        <ImageBackground
            source={require('./assets/hexagon.png')}
            style={[styles.hexagonInner, { width: hexagonSize, height: hexagonSize }]}
            resizeMode="contain"
        >
          {/* Centering container */}
          <View style={styles.contentContainer}>
            <Text style={[styles.title, { fontSize: hexagonFontSize * 1.12 }]}>
              {formatRate()}
            </Text>
            <TranslationView style={[styles.subTitle, { fontSize: hexagonFontSize }]}>
              rate
            </TranslationView>
            <View style={[styles.separator, { width: separatorSize }]} />
            <Text style={[styles.secondTitle, { fontSize: hexagonFontSize * 1.12 }]}>
              {formatDuration()}
            </Text>
            <TranslationView style={[styles.subTitle, { fontSize: hexagonFontSize }]}>
              duration
            </TranslationView>
          </View>
        </ImageBackground>
      </View>
  );
}

export default HexagonView;
